import MicroModal from 'micromodal'
import { Controller } from "stimulus"
export default class extends Controller {
  static targets = ["infoPage", "deleteForm", "contentBody", "closeButton", 
  "nextButton", "submitButton", "errorHandler"];
  static values = {
    count: {type: Number, default: 0}
  }

  connect() {
    this.formData = document.getElementById("delete_account_form");
    this.errorField = document.getElementById("errors");
    this.emptyFieldError = document.getElementById("empty-field").value;
    this.deleteContainer = document.getElementById("delete-container");
  }

  next() {
    this.infoPageTarget.classList.add("hidden");
    this.deleteFormTarget.classList.remove("hidden");
    this.nextButtonTarget.classList.add("hidden");
    this.submitButtonTarget.classList.remove("hidden");
  }

  async submit(event) {
    // as soon as possible this code will be refactored
    event.preventDefault();
    event.stopPropagation();
    document.getElementById("user_password").blur();
    if (document.forms["delete_account_form"]['user[password]'].value.trim().length == 0){
      this.displayErrorMessage(this.emptyFieldError)
    } else {
      var id = document.getElementById("user-id").value;
      var locale = document.getElementById("locale-field").value;
      var data = new FormData()
      data.append("user[password]", document.forms["delete_account_form"]['user[password]'].value)
      data.append("id", id)
      data.append("locale", locale)
      const response = await fetch('/destroy_account', {
        method: "POST",
        body: data,
      });
      const responseData = await response.json();
      const responseStatus = response.status;
      if (responseStatus === 403) {
        this.displayErrorMessage(responseData.message)
      }
      else if (responseStatus === 200 || responseStatus === 204) {
        this.logout();
      } else {
        this.displayErrorMessage("Please, try again after 5 minutes")
      }
    }
  }

  close() {
    this.errorField.classList.add("hidden")
    this.deleteFormTarget.classList.add("hidden");
    this.infoPageTarget.classList.remove("hidden");
    this.nextButtonTarget.classList.remove("hidden");
    this.submitButtonTarget.classList.add("hidden");
    this.formData.reset();
    this.deleteContainer.classList.add("hidden");
  }
  
  open() {
    this.deleteContainer.classList.remove("hidden");
  }

  displayErrorMessage(message){
    this.errorHandlerTarget.innerText = message;
    this.errorField.classList.remove("hidden")
  }

  logout() {
    if (window?.Android && typeof window.Android.deleteAccount == "function") {
      Android.deleteAccount();
      return null;
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "deleteAccount",
      });
    }
  }
}
